<template>
  <div class="container">
    <div class="row" v-if="hasData">
      <div class="col">
        <h4 class="text-capitalize">Appendix: Comments</h4>
        <p v-if="subjectDescription" class="my-4 lead">
          <mark>{{ subjectDescription }}</mark>
        </p>
        <div class="card my-3" v-for="comment in comments" :key="comment.commentId">
          <div class="card-body py-3">
            <p class="font-italic">{{ comment.text }}</p>
            <p class="mb-0 text-muted">{{ comment.userFullName }} on {{ formatter.date.long(comment.timestamp) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
  props: {
    organizationId: String,
    reportId: String,
  },
  data() {
    return {
      report: null,
    };
  },
  computed: {
    formatter: () => formatter,
    hasData() {
      if (this.report && this.report.summary && this.report.summary.scoreCode === "inconclusive") return false;
      if (this.statusCode === "completed") return true;
      return false;
    },
    statusCode() {
      if (this.report && this.report.statusCode) return this.report.statusCode;
      return "unknown";
    },
    subjectType() {
      return this.$route.query.subject_type;
    },
    subjectId() {
      return this.$route.query.subject_id;
    },
    subjectTypeDisplayName() {
      if (this.subjectType === "response") return "question";
      return this.subjectType;
    },
    subjectDescription() {
      var subjectDescription = this.comments && this.comments.length ? this.comments[0].subjectDescription : "";
      if (this.subjectType === "report") return "Report";
      if (this.subjectType === "category") subjectDescription = `Category: ${subjectDescription}`;
      if (this.subjectType === "response") subjectDescription = `Question: ${subjectDescription}`;
      return subjectDescription;
    },
    comments() {
      if (!this.report || !this.report.comments) return [];
      return this.report.comments.filter(c => c.subjectType === this.subjectType && c.subjectId == this.subjectId);
    },
  },
  created() {
    this.$axios
      .get(`/v1/organizations/${this.organizationId}/reports/${this.reportId}`)
      .then(res => (this.report = res.data))
      .catch(err => (this.error = err))
      .finally(() => this.print());
  },
  methods: {
    print() {
      setTimeout(() => (window.printReady = true), 500);
    },
  },
};
</script>
